// Keep this renderer visually aligned with zep-crm admin-web
// `src/crm/components/PopupCard.tsx`. The admin preview is the source of truth.

import { BottomRightCard } from './BottomRightCard';
import { CenterModalCard } from './CenterModalCard';
import { MobileBottomCard } from './MobileBottomCard';
import { POPUP_POSITION, type PopupCardContent, type PopupDevice, type PopupPosition } from './types';
export type { PopupCardContent, PopupDevice, PopupPosition } from './types';
export { getOverlayStyles, toSafeOpenUrl } from './utils';
export function PopupCard({
  content,
  position = POPUP_POSITION.BOTTOM_RIGHT,
  device = 'pc',
  onClose,
  onButtonClick,
  onDismiss
}: {
  content: PopupCardContent;
  position?: PopupPosition;
  device?: PopupDevice;
  onClose?: () => void;
  onButtonClick?: (index: number, url?: string) => void;
  onDismiss?: () => void;
}) {
  const handlers = {
    onClose,
    onButtonClick,
    onDismiss
  };
  if (device === 'mobile') {
    return <MobileBottomCard content={content} {...handlers} />;
  }
  if (position === POPUP_POSITION.CENTER_MODAL) {
    return <CenterModalCard content={content} {...handlers} />;
  }
  return <BottomRightCard content={content} {...handlers} data-sentry-element="BottomRightCard" data-sentry-component="PopupCard" data-sentry-source-file="index.tsx" />;
}